import type { MyPerk, MyPlatform } from '../../domain/entities/platform.entity';
import type { PlatformsApiDatasource } from '../datasources/platforms-api.datasource';

export class PlatformsRepositoryImpl {
  private readonly api: PlatformsApiDatasource;

  constructor(api: PlatformsApiDatasource) {
    this.api = api;
  }

  async getMyPlatforms(): Promise<MyPlatform[]> {
    return this.api.getMyPlatforms();
  }

  async getProfilePerks(platformProfileId: string): Promise<MyPerk[]> {
    return this.api.getProfilePerks(platformProfileId);
  }
}
